import { contractCache } from "services/smartContracts/smartContracts";

export function isDn(addr) {
  return addr === contractCache.identityProxy._address;
}
